module.exports = __webpack_public_path__ + "static/media/logo.134a92c5.png";